import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useDispatch } from "react-redux";
import { validateSession } from "./app/auth/authSlice";
import Toaster from "./app/components/Toaster";
import Redirect from "./app/auth/Redirect";
import AppRoutes from "./components/AppRoutes";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize Redux store with localStorage data on app start
    dispatch(validateSession());
  }, [dispatch]);

  return (
    <Router>
      <Redirect />
      <Toaster />
      <AppRoutes />
    </Router>
  );
}

export default App;
